import {
	Checkbox,
	FormControlLabel,
	IconButton,
	TableCell,
	TableRow,
	Tooltip,
} from "@mui/material";
import { Delete, Edit, FormatListBulletedOutlined } from "@mui/icons-material";
import { AddUpdateCommonRecord } from "./add-update-common-dialog";
import { useState } from "react";
import { DeleteCommonRecord } from "./delete-common-record";
import { ManageRoleDialog } from "./manage-role-dialog";
type ComponentProps = {
	data: any;
	getAllRecords: any;
	addUpdateApiUrl: string;
	deleteApiUrl: string;
	title: string;
};
export function RoleRecordRow(props: ComponentProps) {
	const { data, getAllRecords, title, addUpdateApiUrl, deleteApiUrl } = props;
	const [isUpdateRecordOpen, setIsUpdateRecordOpen] = useState(false);
	const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
	const [isManageDialogHandleClickOpen, setIsManageDialogHandleClickOpen] =
		useState(false);

	return (
		<>
			<TableRow key={data.id}>
				<TableCell>{data.name}</TableCell>
				<TableCell>
					<FormControlLabel
						control={<Checkbox checked={data.isActive ? true : false} />}
						label={data.isActive ? "Active" : "Deactivate"}
					/>
				</TableCell>
				<TableCell>
					<Tooltip title="Manage Role Permission">
						<IconButton
							aria-label="list"
							onClick={() => setIsManageDialogHandleClickOpen(true)}
						>
							<FormatListBulletedOutlined />
						</IconButton>
					</Tooltip>
				</TableCell>
				<TableCell className="action-col" align="center">
					<div className="button-wrapper">
						<Tooltip title="Edit Role">
							<IconButton
								onClick={() => setIsUpdateRecordOpen(true)}
								aria-label="Edit"
								color="primary"
							>
								<Edit />
							</IconButton>
						</Tooltip>
						<Tooltip title="Delete Role">
							<IconButton
								aria-label="Delete"
								onClick={() => setIsDeleteDialogOpen(true)}
								color="primary"
							>
								<Delete />
							</IconButton>
						</Tooltip>
					</div>
				</TableCell>
			</TableRow>
			{/* Update record  */}
			<AddUpdateCommonRecord
				dialogOpen={isUpdateRecordOpen}
				handleOnClickClose={() => setIsUpdateRecordOpen(false)}
				dialogTitle={title}
				apiPath={addUpdateApiUrl}
				data={data}
				getAllRecords={getAllRecords}
			/>
			<DeleteCommonRecord
				getAllRecords={getAllRecords}
				apiPath={`${deleteApiUrl}/${data.id}`}
				dialogOpen={isDeleteDialogOpen}
				handleOnClickClose={() => setIsDeleteDialogOpen(false)}
			/>
			<ManageRoleDialog
				dialogOpen={isManageDialogHandleClickOpen}
				handleOnClickClose={() => setIsManageDialogHandleClickOpen(false)}
				roleId={data.id}
			/>
		</>
	);
}
